import {
  AddProtectionContainerComponent
} from '@additional-services/containers/add-protection-container/add-protection-container.component';
import { Injectable, NgModule } from '@angular/core';
import { CanDeactivate, RouterModule, Routes } from '@angular/router';
import { OfferErrorComponent } from '@core/components/offer-error/offer-error.component';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { LandingComponent } from '@pages/components/landing/landing.component';
import { OptimizelyGuard } from '@shared/services/optimizely-guard.service';
import { UpsellProtectionGuard } from '@shared/services/upsell-protection-guard';
import {
  AdditionalServicesContainerComponent
} from '@additional-services/containers/additional-services-container/additional-services-container.component';
import { OrderFormComponent } from '@complete-order/components/order-form/order-form.component';
import {
  OfferTakenContainerComponent
} from '@confirmation/containers/offer-taken-container/offer-taken-container.component';
import {
  OrderConfirmationContainerComponent
} from '@confirmation/containers/order-confirmation/order-confirmation.container';
import { ErrorComponent } from '@core/components/error/error.component';
import { NotFoundComponent } from '@core/components/not-found/not-found.component';
import { OfferNotFoundComponent } from '@core/components/offer-not-found/offer-not-found.component';
import { UnauthorisedComponent } from '@core/components/unauthorised/unauthorised.component';
import { ModelComparisonContainerComponent } from './model-comparison/model-comparison.container';
import { CompleteOrderComponent } from '@pages/components/complete-order/complete-order.component';
import { OffersComponent } from '@pages/components/offers/offers.component';
import { ProductDetailsComponent } from '@pages/components/product-details/product-details.component';
import { RedirectGuard } from '@shared/services/redirect-guard.service';
import { ProcessingOrderComponent } from '@pages/components/processing-order/processing-order.component';

@Injectable({
  providedIn: 'root',
})
class CanDeactivateProcessingOrder
  implements CanDeactivate<ProcessingOrderComponent>
{
  canDeactivate(component: ProcessingOrderComponent) {
    // Logic to determine if navigation is allowed
    return component.canDeactivate();
  }
}

export const routes: Routes = [
  {
    path: 'PROffer',
    redirectTo: 'tips',
    pathMatch: 'full',
  },
  {
    path: 'tips',
    data: { title: 'Tips' },
    component: LandingComponent,
  },
  {
    path: 'offers',
    data: { title: 'Your replacement options' },
    component: OffersComponent,
    canActivate: [RedirectGuard],
  },
  {
    path: 'processing-order',
    data: { title: 'Processing order' },
    component: ProcessingOrderComponent,
    canDeactivate: [CanDeactivateProcessingOrder],
  },
  {
    path: 'product-details',
    data: { title: 'Product details' },
    component: ProductDetailsComponent,
    canActivate: [RedirectGuard, OptimizelyGuard],
  },
  {
    path: 'model-comparison',
    data: { title: 'Model Comparison' },
    component: ModelComparisonContainerComponent,
    canActivate: [RedirectGuard, OptimizelyGuard],
  },
  {
    path: 'services',
    data: { title: 'Services' },
    component: AdditionalServicesContainerComponent,
    canActivate: [RedirectGuard, OptimizelyGuard],
  },
  {
    path: 'protection',
    data: { title: 'Protection' },
    component: AddProtectionContainerComponent,
    canActivate: [RedirectGuard, OptimizelyGuard, UpsellProtectionGuard],
  },
  {
    path: 'complete-order',
    data: { title: 'Complete your order' },
    component: CompleteOrderComponent,
    canActivate: [RedirectGuard],
  },
  {
    path: 'order-form',
    data: { title: 'Order form' },
    component: OrderFormComponent,
    canActivate: [RedirectGuard],
  },
  {
    path: 'order-confirmation',
    data: { title: 'Order confirmation' },
    component: OrderConfirmationContainerComponent,
    canActivate: [RedirectGuard, OptimizelyGuard],
  },
  {
    path: 'offer-taken',
    data: { title: 'Offer taken' },
    component: OfferTakenContainerComponent,
    canActivate: [RedirectGuard, OptimizelyGuard],
  },
  {
    path: 'unauthorised',
    data: { title: 'Unauthorised' },
    component: UnauthorisedComponent,
  },
  {
    path: 'offer-not-found',
    data: { title: 'Offer not found' },
    component: OfferNotFoundComponent,
  },
  { path: 'error', data: { title: 'Error' }, component: ErrorComponent },
  {
    path: 'offer-error',
    data: { title: 'Offer Error' },
    component: OfferErrorComponent,
  },
  {
    path: '**',
    data: { title: 'Page not found' },
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' }),
    StoreRouterConnectingModule.forRoot(),
  ],
  exports: [RouterModule],
})
export class PrRoutingModule {}
